export const normalizeCenter = (value: unknown): [number, number] | null => {
    if (Array.isArray(value) && value.length >= 2) {
        const latitude = Number(value[0])
        const longitude = Number(value[1])

        return Number.isFinite(latitude) && Number.isFinite(longitude) ? [latitude, longitude] : null
    }

    if (typeof value === 'string') {
        const parts = value
            .replace(/[\[\]\s]/g, '')
            .split(',', 2)
            .map(Number)

        const [latitude, longitude] = parts

        return Number.isFinite(latitude) && Number.isFinite(longitude) ? [latitude, longitude] : null
    }

    return null
}
